<template>
  <div class="grupo-familiar">
    <div
      v-if="beneficiarioSelecionado === null"
    >
      <GrupoFamiliarBeneficiario
        v-if="isBeneficiario"
        v-model="beneficiarioSelecionado"
        :id-funcionalidade="idFuncionalidade"
        :numero-contrato="numeroContrato"
      />
      <GrupoFamiliarContratos
        v-else
        v-model="beneficiarioSelecionado"
        :id-funcionalidade="idFuncionalidade"
        :numero-contrato="numeroContrato"
      />
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GrupoFamiliarBeneficiario from '@/views/53/components/EscolhaContatoBeneficiario'
import GrupoFamiliarContratos from '@/views/53/components/GrupoFamiliarContratos'
import { EnumPerfilUsuario } from '@mobilesaude/frontend_libs/enums/EnumsBeneficiario'

export default {
  name: 'StepGrupoFamiliar',
  components: { GrupoFamiliarContratos, GrupoFamiliarBeneficiario },
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String
    }
  },
  watch: {
    value (newValue) {
      this.beneficiarioSelecionado = newValue
    },
    beneficiarioSelecionado (newValue) {
      // Propaga a mudança no valor
      this.$emit('input', newValue)
      this.$emit('click', newValue)
    }
  },
  data () {
    return {
      beneficiarioSelecionado: null
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['funcParams']),
    isBeneficiario () {
      if ((this.funcParams.dashboard || {}).perfilUsuario) {
        return this.funcParams.dashboard.perfilUsuario === EnumPerfilUsuario.beneficiario
      }
      return true
    }
  }
}
</script>
<style>
</style>
